import { Ng2StateDeclaration } from '@uirouter/angular';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { StateService } from '@uirouter/core';
import { Component } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

@Component({
    selector: 'base-admin',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [
        UIRouterModule,
    ],
})
class AdminComponent {}

export const ADMIN_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin_old',
        url: '/admin_old',
        component: AdminComponent,
        abstract: false,
        data: { anonymous_access: false, sidebar: 'admin' },
        resolve: [
            {
                token: 'removeDomain',
                deps: [CoreDomainService],
                resolveFn: (
                    ng2CoreDomainService: CoreDomainService,
                ) => {
                    ng2CoreDomainService.setDomain(null);
                    ng2CoreDomainService.removeDomainGroup();
                    ng2CoreDomainService.changeDomain();
                },
            },
            {
                token: 'isCustomerAdmin',
                deps: [
                    PipeService,
                    StateService,
                    SessionService,
                    MonUIRouterTransitionService,
                ],
                resolveFn: (
                    ng2PipeService: PipeService,
                    $state: StateService,
                    ng2SessionService: SessionService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                ) => {
                    const customer = ng2SessionService.customer;
                    if (!ng2PipeService.get('role')(['customer_admin']) || !customer) {
                        return ng2MonUIRouterTransitionService.onTransitionFinished(
                            () => {
                                $state.go('base.dashboard');
                            },
                        );
                    }
                    return Promise.resolve(true);
                },
            },
        ],
    },
];
